export default __webpack_public_path__ + "static/media/arrow-down-grey.a678686d.svg";